var uiCopyToClipboard = {
	copy: "Kopieren Sie \"{value}\" in die Zwischenablage",
	successMessage: "Kopiert",
	failureMessage: "Kopieren nicht möglich"
};
var uiCopyToClipboardTranslationsDe = {
	uiCopyToClipboard: uiCopyToClipboard
};

export { uiCopyToClipboardTranslationsDe as default, uiCopyToClipboard };
